import React, { useMemo, useState } from 'react';
import Box from '@mui/material/Box';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DealDetails } from 'src/components/ApartmentConnectDeal/components/DealDetails/dealDetails';
import { IBitrixDeal, IBitrixDealPlacement } from 'src/store/crosstable/reducer';
import { translations } from 'src/constants/translations';
import { useStyles as otherDealsStyles } from './otherDealsStyles';
import { useStyles as currentDealStyles } from './currentDealStyles';

interface DealDetailsWrapperProps {
  bitrixDeal: IBitrixDeal | null;
  placementDeal: IBitrixDealPlacement | undefined;
  onUnlink: (dealId: string) => void;
}
export const DealDetailsWrapper: React.FC<DealDetailsWrapperProps> = ({
  bitrixDeal, placementDeal, onUnlink,
}) => {
  const currentDeal = currentDealStyles();
  const otherDeals = otherDealsStyles();
  // "Other linked deals (N)" header collapse (chevron in the design).
  const [othersCollapsed, setOthersCollapsed] = useState(false);
  const filteredOtherDeals = useMemo(() => placementDeal?.bitrixDeals?.filter(
    (deal) => deal.id !== bitrixDeal?.id,
  ) || [], [bitrixDeal, placementDeal]);
  return (
    <>
      {bitrixDeal && (
        <React.Fragment key={bitrixDeal.id}>
          <DealDetails
            styles={currentDeal}
            title="CURRENT DEAL"
            bitrixDeal={bitrixDeal}
            onUnlink={onUnlink}
          />
        </React.Fragment>
      )}
      {/* The accordion header only makes sense for 2+ other deals; a single
          deal renders as a plain always-visible card. */}
      {filteredOtherDeals.length > 1 && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          fontSize="12px"
          fontWeight={500}
          color="#1D1D1F"
          onClick={() => setOthersCollapsed((v) => !v)}
          data-testid="other-deals-header"
          style={{ cursor: 'pointer' }}
        >
          {`${translations.otherLinkedDeals} (${filteredOtherDeals.length})`}
          <ExpandMoreIcon
            sx={{
              fontSize: 16,
              transform: othersCollapsed ? 'none' : 'rotate(180deg)',
              transition: 'transform 120ms ease-out',
            }}
          />
        </Box>
      )}
      {/* With no header (0-1 deals) the list ignores a stale collapsed state —
          e.g. collapsed with 2 deals, then one gets unlinked. */}
      {(filteredOtherDeals.length <= 1 || !othersCollapsed) && filteredOtherDeals.map((deal) => (
        <React.Fragment key={deal.id}>
          <DealDetails
            styles={otherDeals}
            title="DEAL"
            placementDeal={placementDeal}
            bitrixDeal={bitrixDeal}
            otherDeal={deal}
            onUnlink={onUnlink}
          />
        </React.Fragment>
      ))}
    </>
  );
};
